import moment from 'moment';
import { TIME_3HOURS, TIME_TODAY, TIME_TOMORROW } from 'nike-ui/src/components/betbook/constants';

const tomorow = () => moment().add('1', 'days');

const hours3 = () =>
    moment()
        .add('3', 'hours')
        .format();

export const timeFilterIntervals = {
    [TIME_TODAY]: {
        expirationFrom: () => moment().format(),
        expirationTo: () =>
            moment()
                .endOf('day')
                .format()
    },
    [TIME_TOMORROW]: {
        expirationFrom: () =>
            tomorow()
                .startOf('day')
                .format(),
        expirationTo: () =>
            tomorow()
                .endOf('day')
                .format()
    },
    [TIME_3HOURS]: {
        expirationFrom: () => moment().format(),
        expirationTo: hours3
    }
};
